import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import jaLogin from './locales/ja/login.json';
import enLogin from './locales/en/login.json';
import jaCommon from './locales/ja/common.json';
import enCommon from './locales/en/common.json';
import jaHeader from './locales/ja/header.json';
import enHeader from './locales/en/header.json';
import jaFooter from './locales/ja/footer.json';
import enFooter from './locales/en/footer.json';
import jaHomeHero from './locales/ja/homeHero.json';
import enHomeHero from './locales/en/homeHero.json';
import jaEventCard from './locales/ja/eventCard.json';
import enEventCard from './locales/en/eventCard.json';
import jaPurchaseButton from './locales/ja/purchaseButton.json';
import enPurchaseButton from './locales/en/purchaseButton.json';
import jaResendVerification from './locales/ja/resendVerification.json';
import enResendVerification from './locales/en/resendVerification.json';
import jaAnnouncementBar from './locales/ja/announcementBar.json';
import enAnnouncementBar from './locales/en/announcementBar.json';
import jaGalleryLightbox from './locales/ja/galleryLightbox.json';
import enGalleryLightbox from './locales/en/galleryLightbox.json';
import jaNotFound from './locales/ja/notFound.json';
import enNotFound from './locales/en/notFound.json';
import jaPurchaseResult from './locales/ja/purchaseResult.json';
import enPurchaseResult from './locales/en/purchaseResult.json';
import jaAuth from './locales/ja/auth.json';
import enAuth from './locales/en/auth.json';
import jaEventCancelled from './locales/ja/eventCancelled.json';
import enEventCancelled from './locales/en/eventCancelled.json';
import jaRegister from './locales/ja/register.json';
import enRegister from './locales/en/register.json';
import jaEventsSearch from './locales/ja/eventsSearch.json';
import enEventsSearch from './locales/en/eventsSearch.json';
import jaContact from './locales/ja/contact.json';
import enContact from './locales/en/contact.json';
import jaHomePage from './locales/ja/homePage.json';
import enHomePage from './locales/en/homePage.json';
import jaProfile from './locales/ja/profile.json';
import enProfile from './locales/en/profile.json';
import jaApplicationConfirm from './locales/ja/applicationConfirm.json';
import enApplicationConfirm from './locales/en/applicationConfirm.json';
import jaEventDetail from './locales/ja/eventDetail.json';
import enEventDetail from './locales/en/eventDetail.json';
import jaLanding from './locales/ja/landing.json';
import enLanding from './locales/en/landing.json';
import jaFaq from './locales/ja/faq.json';
import enFaq from './locales/en/faq.json';
import jaHelp from './locales/ja/help.json';
import enHelp from './locales/en/help.json';
import jaDashboard from './locales/ja/dashboard.json';
import enDashboard from './locales/en/dashboard.json';
import jaCheckin from './locales/ja/checkin.json';
import enCheckin from './locales/en/checkin.json';
import jaSales from './locales/ja/sales.json';
import enSales from './locales/en/sales.json';
import jaKycGuide from './locales/ja/kycGuide.json';
import enKycGuide from './locales/en/kycGuide.json';
import jaCredentials from './locales/ja/credentials.json';
import enCredentials from './locales/en/credentials.json';
import jaOrganizerRegister from './locales/ja/organizerRegister.json';
import enOrganizerRegister from './locales/en/organizerRegister.json';
import jaVenueRegister from './locales/ja/venueRegister.json';
import enVenueRegister from './locales/en/venueRegister.json';
import jaLegal from './locales/ja/legal.json';
import enLegal from './locales/en/legal.json';
import jaTermsReagreement from './locales/ja/termsReagreement.json';
import enTermsReagreement from './locales/en/termsReagreement.json';
import jaCreateEvent from './locales/ja/createEvent.json';
import enCreateEvent from './locales/en/createEvent.json';
import jaErrorBoundary from './locales/ja/errorBoundary.json';
import enErrorBoundary from './locales/en/errorBoundary.json';
import jaGalleryImageCard from './locales/ja/galleryImageCard.json';
import enGalleryImageCard from './locales/en/galleryImageCard.json';
import jaEventImageUploader from './locales/ja/eventImageUploader.json';
import enEventImageUploader from './locales/en/eventImageUploader.json';
import jaVenueMap from './locales/ja/venueMap.json';
import enVenueMap from './locales/en/venueMap.json';
import jaEventGallery from './locales/ja/eventGallery.json';
import enEventGallery from './locales/en/eventGallery.json';
import jaMyEventMemories from './locales/ja/myEventMemories.json';
import enMyEventMemories from './locales/en/myEventMemories.json';
import jaGalleryAdmin from './locales/ja/galleryAdmin.json';
import enGalleryAdmin from './locales/en/galleryAdmin.json';
import jaApiErrors from './locales/ja/apiErrors.json';
import enApiErrors from './locales/en/apiErrors.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      ja: {
        login: jaLogin,
        common: jaCommon,
        header: jaHeader,
        footer: jaFooter,
        homeHero: jaHomeHero,
        eventCard: jaEventCard,
        purchaseButton: jaPurchaseButton,
        resendVerification: jaResendVerification,
        announcementBar: jaAnnouncementBar,
        galleryLightbox: jaGalleryLightbox,
        notFound: jaNotFound,
        purchaseResult: jaPurchaseResult,
        auth: jaAuth,
        eventCancelled: jaEventCancelled,
        register: jaRegister,
        eventsSearch: jaEventsSearch,
        contact: jaContact,
        homePage: jaHomePage,
        profile: jaProfile,
        applicationConfirm: jaApplicationConfirm,
        eventDetail: jaEventDetail,
        landing: jaLanding,
        faq: jaFaq,
        dashboard: jaDashboard,
        checkin: jaCheckin,
        sales: jaSales,
        kycGuide: jaKycGuide,
        credentials: jaCredentials,
        organizerRegister: jaOrganizerRegister,
        venueRegister: jaVenueRegister,
        legal: jaLegal,
        termsReagreement: jaTermsReagreement,
        createEvent: jaCreateEvent,
        errorBoundary: jaErrorBoundary,
        galleryImageCard: jaGalleryImageCard,
        eventImageUploader: jaEventImageUploader,
        venueMap: jaVenueMap,
        eventGallery: jaEventGallery,
        myEventMemories: jaMyEventMemories,
        galleryAdmin: jaGalleryAdmin,
        apiErrors: jaApiErrors,
        help: jaHelp,
      },
      en: {
        login: enLogin,
        common: enCommon,
        header: enHeader,
        footer: enFooter,
        homeHero: enHomeHero,
        eventCard: enEventCard,
        purchaseButton: enPurchaseButton,
        resendVerification: enResendVerification,
        announcementBar: enAnnouncementBar,
        galleryLightbox: enGalleryLightbox,
        notFound: enNotFound,
        purchaseResult: enPurchaseResult,
        auth: enAuth,
        eventCancelled: enEventCancelled,
        register: enRegister,
        eventsSearch: enEventsSearch,
        contact: enContact,
        homePage: enHomePage,
        profile: enProfile,
        applicationConfirm: enApplicationConfirm,
        eventDetail: enEventDetail,
        landing: enLanding,
        faq: enFaq,
        dashboard: enDashboard,
        checkin: enCheckin,
        sales: enSales,
        kycGuide: enKycGuide,
        credentials: enCredentials,
        organizerRegister: enOrganizerRegister,
        venueRegister: enVenueRegister,
        legal: enLegal,
        termsReagreement: enTermsReagreement,
        createEvent: enCreateEvent,
        errorBoundary: enErrorBoundary,
        galleryImageCard: enGalleryImageCard,
        eventImageUploader: enEventImageUploader,
        venueMap: enVenueMap,
        eventGallery: enEventGallery,
        myEventMemories: enMyEventMemories,
        galleryAdmin: enGalleryAdmin,
        apiErrors: enApiErrors,
        help: enHelp,
      },
    },
    lng: localStorage.getItem('language') || (navigator.language.startsWith('ja') ? 'ja' : 'en'),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
